import { render } from "./health.vue?vue&type=template&id=18894236&scoped=true&ts=true"
import script from "./health.vue?vue&type=script&lang=ts"
export * from "./health.vue?vue&type=script&lang=ts"

import "./health.vue?vue&type=style&index=0&id=18894236&lang=less&scoped=true"

import exportComponent from "D:\\project\\mpe-project\\vue-project\\mobile-mpe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18894236"]])

export default __exports__